import React from 'react'
import { Alert } from "@mui/material";

/**
 * 青枠付で文を表示する
 */
export function Info({children}: {children: React.ReactNode}) {
    return(
        <>
            <Alert icon={false} severity="info"
                sx={{
                    mt:1,
                    textAlign:"left"
                }}
            >
                {children}
            </Alert> 
        </>
    );
}